import { render, staticRenderFns } from "./creditNotesTable.vue?vue&type=template&id=4753439c"
import script from "./creditNotesTable.vue?vue&type=script&lang=ts"
export * from "./creditNotesTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports